import { render, staticRenderFns } from "./RequestModal.vue?vue&type=template&id=6ba3a508&scoped=true"
import script from "./RequestModal.vue?vue&type=script&lang=js"
export * from "./RequestModal.vue?vue&type=script&lang=js"
import style0 from "./RequestModal.vue?vue&type=style&index=0&id=6ba3a508&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba3a508",
  null
  
)

export default component.exports